import { CSSProperties, FC } from "react";
import { Table } from "antd";
import { clsx } from "clsx";
import { Issue } from "../../../../types/IntelligenceTypes";
import styles from "./MarketTrendsCommon.module.less";

const { Column } = Table;

interface LegalIssuesProps {
    data?: Issue[];
    style?: CSSProperties;
}

export const LegalIssues: FC<LegalIssuesProps> = ({ data, style }) => {
    if (!data?.length) return null;

    return (
        <div style={style}>
            <div className={clsx(styles.tableTitle, "sectionTitle")}>
                Legal and compliance Issues
            </div>
            <Table dataSource={data} pagination={false} size="small">
                <Column title="Issue" dataIndex="issue" width={334} />
                <Column title="Severity" dataIndex="severity" width={334} />
                <Column title="Timeline" dataIndex="timeline" />
            </Table>
        </div>
    );
};
